// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-typography{
  font-family: "Poppins" !important;
}

.keywordsPick{
  display: -webkit-box !important;
 -webkit-line-clamp: 1;   /* number of lines */
 -webkit-box-orient: vertical;
 overflow: hidden;
 text-overflow: ellipsis;
 word-break: break-word;  /* ensures long words don’t overflow */
 white-space: normal;
 }
.product-section {
  flex: 1 1;
  padding: 14px;
}
.product-section-new{
  background: white;
  padding: 2px;
}
.product-link-rendering-section-new
{ background: white;
  padding: 2px;
}
.wedsiteBreadcrumb{
  background:white;
  padding:24px 1%;

}

.product-section .ant-typography {
  font-size: 14px;
}
.top-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.top-icon img {
  height: 50px; /* adjust size */
}

.section-subtitle {
  font-size: 12px !important;
}
@media (max-width: 768px) {

  .product-section {
    padding: 8px;
  }

  /* .product-section .ant-typography {
    font-size: 12px;
  } */

  .product-section .section-subtitle {
    font-size: 12px !important;
  }
  .section-subtitle {
    font-size: 12px !important;
  }

}
@media (min-width:700px) {
  .product-section-new{
  /* padding: 14px 10%; */
}
.product-link-rendering-section-new{
  padding: 14px 15%;
}
.wedsiteBreadcrumb{
  background:white;
  padding:24px 10%;

}
}

@media (min-width:1024px){
  .product-section-new{
  /* padding: 14px 10%; */
}
.product-link-rendering-section-new{
  padding: 14px 30%;
}
.wedsiteBreadcrumb{
  background:white;
  padding:24px 10%;

}
}`, "",{"version":3,"sources":["webpack://./src/pages/UI_Recommendations/ProductPage.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;CAChC,qBAAqB,IAAI,oBAAoB;CAC7C,4BAA4B;CAC5B,gBAAgB;CAChB,uBAAuB;CACvB,sBAAsB,GAAG,sCAAsC;CAC/D,mBAAmB;CACnB;AACD;EACE,SAAO;EACP,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;;AAEjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY,EAAE,gBAAgB;AAChC;;AAEA;EACE,0BAA0B;AAC5B;AACA;;EAEE;IACE,YAAY;EACd;;EAEA;;KAEG;;EAEH;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;;AAEF;AACA;EACE;EACA,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;;AAElB;AACA;;AAEA;EACE;EACA,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;;AAElB;AACA","sourcesContent":[".ant-typography{\n  font-family: \"Poppins\" !important;\n}\n\n.keywordsPick{\n  display: -webkit-box !important;\n -webkit-line-clamp: 1;   /* number of lines */\n -webkit-box-orient: vertical;\n overflow: hidden;\n text-overflow: ellipsis;\n word-break: break-word;  /* ensures long words don’t overflow */\n white-space: normal;\n }\n.product-section {\n  flex: 1;\n  padding: 14px;\n}\n.product-section-new{\n  background: white;\n  padding: 2px;\n}\n.product-link-rendering-section-new\n{ background: white;\n  padding: 2px;\n}\n.wedsiteBreadcrumb{\n  background:white;\n  padding:24px 1%;\n\n}\n\n.product-section .ant-typography {\n  font-size: 14px;\n}\n.top-icon {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 1rem;\n}\n\n.top-icon img {\n  height: 50px; /* adjust size */\n}\n\n.section-subtitle {\n  font-size: 12px !important;\n}\n@media (max-width: 768px) {\n\n  .product-section {\n    padding: 8px;\n  }\n\n  /* .product-section .ant-typography {\n    font-size: 12px;\n  } */\n\n  .product-section .section-subtitle {\n    font-size: 12px !important;\n  }\n  .section-subtitle {\n    font-size: 12px !important;\n  }\n\n}\n@media (min-width:700px) {\n  .product-section-new{\n  /* padding: 14px 10%; */\n}\n.product-link-rendering-section-new{\n  padding: 14px 15%;\n}\n.wedsiteBreadcrumb{\n  background:white;\n  padding:24px 10%;\n\n}\n}\n\n@media (min-width:1024px){\n  .product-section-new{\n  /* padding: 14px 10%; */\n}\n.product-link-rendering-section-new{\n  padding: 14px 30%;\n}\n.wedsiteBreadcrumb{\n  background:white;\n  padding:24px 10%;\n\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
